import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { darkModeAssets } from './darkModeAssets'
import { lightModeAssets } from './lightModeAssets';

export const useAssets = () => {
    const [assets, setAssets] = useState(darkModeAssets);
    const isDark = useSelector(state => state.utils.isDarkMode);

    useEffect(() => {
        if (isDark) {
            setAssets(darkModeAssets)
        } else {
            setAssets(lightModeAssets)
        }
    }, [isDark])

    return assets;
    
}
